<div class="fantasy-container">
  <fgb-page-header [showFooter]="false" [backButtonLink]="'/games'" [pageTitle]="'fantasy.page.title'"></fgb-page-header>

  <ng-container *ifScreenSize="screenType.Desktop">
    <div class="container d-flex flex-column pt-3">
      <a class="text-white fw-bold d-flex flex-row align-items-center" [routerLink]="'/games'"
        ><span class="pe-2 material-icons fw-bold">keyboard_arrow_left</span>{{ 'games.back.btn' | translate }}</a
      >

      <img class="banner-img" [src]="'/banners/games/pick-a-player-banner.png' | contentAssetImage" alt="pick a player banner" />
    </div>
  </ng-container>
  <ng-container *ifScreenSize="screenType.Mobile">
    <div class="container mobile-banner-container">
      <img
        class="banner-img mt-0"
        [src]="'/banners/games/pick-a-player-banner.png' | contentAssetImage"
        alt="pick a player banner"
      />
    </div>
  </ng-container>

  <ng-container *ifScreenSize="screenType.Mobile">
    <div class="container points-leaderboard-container d-flex flex-row w-100">
      <div class="leaderboard-container justify-content-between d-flex flex-row bg-primary align-items-center">
        <div class="rank-icon">
          <span class="material-symbols-outlined"> crown </span>
        </div>
        <div class="rank-details d-flex flex-column align-items-end">
          <p class="font-size-10 text-uppercase text-white fw-bold mb-0">{{ 'fantasy.season.rank' | translate }}</p>

          <p class="font-size-24 text-white fw-bold mb-0">{{ currentUser?.Position || '-' }}</p>
        </div>
      </div>

      <div class="points-container d-flex flex-row justify-content-between bg-primary align-items-center">
        <div class="rank-icon">
          <span class="material-symbols-outlined"> trending_up </span>
        </div>
        <div class="points-details d-flex flex-column align-items-end">
          <p class="font-size-10 text-uppercase text-white fw-bold mb-0">{{ 'fantasy.total.points' | translate }}</p>

          <p class="font-size-24 text-white fw-bold mb-0">{{ currentUser?.Points || 0 }}</p>
        </div>
      </div>
    </div>
  </ng-container>

  <fgb-fantasy-nav></fgb-fantasy-nav>
  <router-outlet></router-outlet>
</div>
